import React, { useEffect, useState} from 'react';
import { Link, useLocation } from 'react-router-dom'
import * as FaIcons from 'react-icons/fa6';
import * as MdIcons from 'react-icons/md';
import { HelmetAsync } from '../utils/HelmetAsync';
import GoToTop from '../utils/GoToTop';
// import { fetchOfficeComplaintStats, fetchStats, fetchVisitorStats, transformDataForChart, transformDataForBarChart } from '../../services/api';
import { Row, Col } from 'react-bootstrap';
import Button from '../components/ui/Button';

// import PieChart from '../../components/chart/PieChart';
// import BarChart from '../../components/chart/BarChart';
// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from "chart.js"

// Register ChartJS components
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement)

function Dashboard() {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    const userRole = localStorage.getItem('userRole');
    const userName = localStorage.getItem('userName');
    const userCompany = localStorage.getItem('userCompany');

    const [stats, setStats] = useState([]);
    const [statusD, setStatusD] = useState([]);

    const location = useLocation();

    // useEffect(() => {
    //     const fetchData = async () => {
    //         const data = await fetchOfficeComplaintStats('2024-12-01', '2025-01-31');
    //         setStats(data);
    //     };

    //     fetchData();
    // }, []);

    const [pieChartData, setPieChartData] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [],
            },
        ],
    });

    const [pieChartData1, setPieChartData1] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [],
            },
        ],
    });

    const [pieChartData2, setPieChartData2] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [],
            },
        ],
    });

    // useEffect(() => {
    //     const fetchData = async () => {
    //         const categorydistribution = await fetchVisitorStats('assemblyConstituency');
    //         const categoryData = transformDataForBarChart(categorydistribution);
    //         setPieChartData2(categoryData);

    //         const statusdistribution = await fetchStats('complaintStatus');
    //         setStatusD(statusdistribution);
    //         const statusData = transformDataForChart(statusdistribution);
    //         setPieChartData(statusData);

    //         const officedistribution = await fetchStats('office');
    //         const officeData = transformDataForBarChart(officedistribution);
    //         setPieChartData1(officeData);


    //         // console.log(categorydistribution)
    //         // console.log(statusData)
    //     };

    //     fetchData();
    // }, []);

    const [userDropdownOpen, setUserDropdownOpen] = useState(false);

    const toggleUserDropdown = () => {
        setUserDropdownOpen(!userDropdownOpen);
    };

    const title = `Dashboard - BreyERP`;

    return (
    <>
        <HelmetAsync title={title} />
        <div className="flex items-center justify-between mb-3">
            <h1 className="text-xl font-bold">Dashboard</h1>
            {/* <p className='m-0 text-lg-right'>{userName}</p> */}
            <Link to="/profile">
                <div className=" flex items-center justify-center text-gray-600 text-sm font-semibold border border-blue-600 px-2 py-1 rounded shadow-sm">
                {["super_admin", "admin_user"].includes(userRole) && (
                <FaIcons.FaUserShield size={18} className='mr-1 text-green-600'/>
                )}
                {["process_user", "item_user"].includes(userRole) && (
                <FaIcons.FaUser size={14} className='mr-1 text-orange-600'/>
                )}
                {userCompany}
                </div>
            </Link>

            {/* <div className="relative">
                <Button 
                    onClick={toggleUserDropdown}
                >
                    <MdIcons.MdAdd className='inline mb-1'/> New <FaIcons.FaChevronDown size={12} className={`inline mb-1 transition-transform ${userDropdownOpen ? 'rotate-180' : ''}`} />
                </Button>
                
                {userDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 ring-1 ring-black ring-opacity-5 z-50">
                    <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Profile
                    </a>
                    <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Settings
                    </a>
                    <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    <div className="flex items-center">
                        <MdIcons.MdLogout className="h-4 w-4 mr-2" />
                        Sign out
                    </div>
                    </a>
                </div>
                )}
            </div> */}
        </div>
        <div className="container pb-5">
            {/* Stats Cards */}
            <div className="bg-round">
                <div className="row">
                    <div className="col text-center">
                    {/* <p className='mt-4'>Welcome, {userName}!</p> */}
                    {["super_admin", "admin_user", "item_user"].includes(userRole) && (
                        <>
                        <Link to="/inventory" className="btn btn-primary m-4">Manage Inventory</Link>
                        <Link to="/rgp" className="btn btn-primary m-4">Manage RGP</Link>
                        </>
                    )}
                    {["super_admin", "admin_user", "process_user"].includes(userRole) && (
                        <Link to="/process-sheet" className="btn btn-primary m-4">Manage Process Sheets</Link>
                    )}
                    </div>
                    {/* {statusD.map((item) => (
                    <div className="col-md-4" key={item._id}>
                        <div className="stats-card">
                            <FaClipboardList size={24} className="mb-2" />
                            <h3>{item.count}</h3>
                            <p className='m-0'>{item._id}</p>
                        </div>
                    </div>
                    ))} */}
                    {/* <div className="col-md-4">
                    <div className="stats-card">
                        <FaUserClock size={24} className="mb-2" />
                        <h3>907</h3>
                        <p className='m-0'>Pending Complaints</p>
                    </div>
                    </div>
                    <div className="col-md-4">
                    <div className="stats-card">
                        <FaChartPie size={24} className="mb-2" />
                        <h3>125</h3>
                        <p className='m-0'>Resolved Complaints</p>
                    </div>
                    </div> */}
                </div>
            </div>

            <div className="">
                <Row className="g-4">
                    <Col xs={12} md={8} className='px-0'>
                        {/* <Row className="g-4">
                            <Col xs={12}>
                                <BarChart data={barChartData} title="केंद्रों पर आंकड़े" />
                            </Col>
                            <Col xs={12}>
                                <BarChart data={barChartData} title="केंद्रों पर आंकड़े" />
                            </Col>
                        </Row> */}
                    </Col>
                    <Col xs={12} md={4} className='px-0'>
                        {/* <BarChart data={pieChartData2} /> */}
                    </Col>
                    <Col xs={12} md={4} className='px-0'>
                        {/* <PieChart data={pieChartData} /> */}
                    </Col>
                    <Col xs={12} md={8} className='px-0'>
                        {/* <BarChart data={pieChartData1} position='bottom' /> */}
                    </Col>
                </Row>
            </div>

            </div>
            <GoToTop/>
        </>
    );
}

export default Dashboard;